// src/App.js

import React, { Suspense, lazy } from 'react';
import { BrowserRouter as CoreRouter, useLocation } from 'react-router-dom';
import NotificationsSystem, { atalhoTheme, useNotifications, setUpNotifications } from 'reapop';
import 'react-month-picker/css/month-picker.css';
import 'react-tooltip/dist/react-tooltip.css';
import './_Assets/scss/volt.scss';
import './_Assets/App.css';
import './variables.css';

import { LayoutPublic } from './Components/_UI/_LayoutsApp';
import { safeGetAuthToken } from './Helpers/authStorage';
import { useJwt } from 'react-jwt';
// 👇 Importamos el widget del bot IA
import SupportBotWidget from './Components/Private/_Dashboard/SupportBotWidget';
import { PeriodLockedProvider } from './_Hooks/_Context/PeriodLockedContext';
import { EnvioInformeJobProvider } from './_Hooks/_Context/EnvioInformeJobContext';

setUpNotifications({
  defaultProps: {
    position: 'top-right',
    dismissible: true,
    dismissAfter: 3000,
    allowHTML: true
  }
});

const AppRouter = lazy(() => import('./AppRouter'));

const SupportBotFloating = ({ enabled }) => {
  const location = useLocation();
  if (!enabled) return null;
  const pathname = (location.pathname || '').toLowerCase();
  const isDashboardRoute =
    pathname === '/' ||
    pathname === '/dashboard' ||
    pathname.startsWith('/dashboard/');
  if (isDashboardRoute) {
    return null;
  }
  return <SupportBotWidget />;
};

export const App = () => {
  const authState = safeGetAuthToken();
  const isLogged = !!authState?.token;
  const rawToken = authState?.token || '';
  const { decodedToken } = useJwt(rawToken);
  const decodedRole = (decodedToken?.role || '').toUpperCase();
  const storedRole = (authState?.metadata?.role || '').toUpperCase();
  const authRole = storedRole || decodedRole;
  const normalizedRole = (authRole || '').toUpperCase();
  const isOwnerRole = normalizedRole === 'PROPIETARIO';
  const useHeaderV2 = process.env.REACT_APP_HEADER_V2 === 'true';
  const useHeaderV2Pro = process.env.REACT_APP_HEADER_V2_PRO === 'true';
  const assistantEnv = process.env.REACT_APP_ASSISTANT_IN_HEADER;
  const assistantInHeader =
    assistantEnv !== undefined
      ? assistantEnv === 'true'
      : (useHeaderV2 || useHeaderV2Pro);

  const { notifications, dismissNotification } = useNotifications();

  return (
    <CoreRouter>
      <PeriodLockedProvider>
        <div>
          <NotificationsSystem
            notifications={notifications}
            dismissNotification={(id) => dismissNotification(id)}
            theme={atalhoTheme}
          />
        </div>

        <Suspense fallback={<div>Loading...</div>}>
          {!isLogged ? (
            <LayoutPublic>
              <AppRouter isLogged={isLogged} authRole={normalizedRole} />
            </LayoutPublic>
          ) : isOwnerRole ? (
            <LayoutPublic>
              <AppRouter isLogged={isLogged} authRole={normalizedRole} />
            </LayoutPublic>
          ) : (
            <EnvioInformeJobProvider>
              {/* Fix layout-doble-montaje (aprobado): AppRouter ya envuelve
                  sus rutas admin en LayoutWAM (AppRouter.js:633), que es el
                  que provee el <Outlet/> real -- este nivel externo solo
                  duplicaba sidebar/header/polling sin aportar nada. */}
              <AppRouter isLogged={isLogged} authRole={normalizedRole} />
              {/* 👇 El asistente IA flotante se oculta en el dashboard principal */}
              <SupportBotFloating enabled={!assistantInHeader} />
            </EnvioInformeJobProvider>
          )}
        </Suspense>
      </PeriodLockedProvider>
    </CoreRouter>
  );
};
